import PropTypes from 'prop-types';
import React, { useCallback, useReducer } from 'react';
import { makeStyles } from 'tss-react/mui';

import { VisibilityOffOutlined, VisibilityOutlined } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

const useStyles = makeStyles()({
    container: {
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap'
    }
});

const HiddenField = ({ text, open, mask, iconSize, slice, className }) => {
    const [hidden, toggleHidden] = useReducer((state) => !state, !open);

    const handleClick = useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleHidden();
    }, []);

    const { classes, cx } = useStyles();

    return (
        <Box className={cx(classes.container, className)}>
            {hidden ? text.slice(0, slice).concat(mask) : text}
            <Tooltip title={hidden ? 'Show Key' : 'Hide key'}>
                <IconButton onClick={handleClick} size={iconSize}>
                    {hidden ? <VisibilityOffOutlined /> : <VisibilityOutlined />}
                </IconButton>
            </Tooltip>
        </Box>
    );
};

HiddenField.propTypes = {
    text: PropTypes.string,
    open: PropTypes.bool,
    mask: PropTypes.string,
    slice: PropTypes.number,
    iconSize: PropTypes.string,
    className: PropTypes.string
};

HiddenField.defaultProps = {
    text: '',
    open: false,
    mask: ' * * * * * * * * * * ',
    slice: 6,
    iconSize: 'medium'
};

export default HiddenField;
